/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DetailCtrlList.vue?vue&type=template&id=7268e6c0&"
import script from "./DetailCtrlList.vue?vue&type=script&lang=js&"
export * from "./DetailCtrlList.vue?vue&type=script&lang=js&"
import style0 from "./DetailCtrlList.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports